// extracted by mini-css-extract-plugin
export default {"root":"SideBar_root__H1sSC","container":"SideBar_container__U65NU","link":"SideBar_link__ZL37J","selected":"SideBar_selected__g55oq","label":"SideBar_label__vu+pX"};